import React, { useContext } from 'react';
import Intl from '@fx-ui/intl';
import { Combo } from '@fx-ui/fine-design';
import { getCorpIndustry, isFavoritesStandalone, isPersonaFieldAvailable } from '~/utils';
import PersonaContext from '../../context/persona';
import PersonaCollectItem from '../persona-collect-item';

/**
 * 所属行业
 */
const Industry = () => {
    const { personaInfo, setPersonaInfo, personaLabel } = useContext(PersonaContext);
    const { industry } = personaInfo || {};

    // 管理需求单独配置时，切换行业不再联动清空已选需求
    const isStandaloneFavorites = isFavoritesStandalone(personaLabel);

    if (!isPersonaFieldAvailable(personaLabel, 'industry')) {
        return null;
    }

    return (
        <PersonaCollectItem
            className="fx-persona-industry"
            title={Intl.get('personal.company.industry')}
        >
            <Combo
                className="industry-combo"
                hasSearch={false}
                placeholder={Intl.get('personal.company.industry.chose')}
                value={industry?.value}
                style={{ width: '100%' }}
                items={getCorpIndustry(personaLabel || [])}
                hasClear={false}
                onChange={(_, item: any) => {
                    setPersonaInfo({
                        industry: item,
                        hasChosenIndustry: true,
                        // 联动场景下，切换行业需要清空【管理需求】
                        ...(isStandaloneFavorites ? {} : { favorites: [], hasChosenDemand: false })
                    });
                }}
                onAfterDropdownVisibleChange={(visible) => {
                    if (visible) {
                        setPersonaInfo({
                            hasChosenIndustry: true,
                            ...(isStandaloneFavorites ? {} : { hasChosenDemand: false })
                        });
                    }
                }}
            />
        </PersonaCollectItem>
    );
};

export default Industry;
